import { Fragment } from 'react';

import useMeetAdminStaffDetail from './UseMeetAdminStaffDetail';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Constants from '@usas/ui-web/utils/Constants';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MeetAdminStaffDetail = () => {
  const { meetAdminStaffState, meetState, formState, errorState, setFormData, handleSubmit, onFormValueChanged,
    onSaveButtonClicked, onBackButtonClicked } = useMeetAdminStaffDetail();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{formState.personId !== '' ? 'Edit' : 'Add'} Meet Administrator</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-4'>
            <ReadOnly
              label={'Position'}
              name={'meetAdminStaffTypeName'}
              value={formState.meetAdminStaffTypeName} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup
              label={'Member Id*'}
              memberIdName={'memberId'}
              formState={formState}
              errorState={errorState}
              setFormData={setFormData}
              onFormValueChanged={onFormValueChanged} />
          </div>
        </div>
        <div className='row usas-extra-top-margin'>
          <div className='col-xs-12'>
            {errorState?.error && <p className={[global.ErrorMessage, global.Multiline].join(' ')}>{errorState?.error}</p>}
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onSaveButtonClicked}>Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackButtonClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={meetAdminStaffState.isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={meetState.isObjLoading} />
    </Fragment>
  );
};

export default MeetAdminStaffDetail;